import api from './api';

const BASE_PATH = '/matriz_saeb/matrix';

/**
 * Cliente da matriz pedagógica multi-etapa do Projeto Floriano.
 * Backend em backend/app/controllers/api/v1/matriz_saeb/matrices_controller.rb.
 */
export const matrizSaebMatrixApi = {
  // GET /api/v1/matriz_saeb/matrix?etapa=ano_9_ef
  show: etapa => api.get(BASE_PATH, { params: { etapa } })
};
